import React, { useEffect, useState } from "react";
import * as S from "./styles";
import * as interFace from "../../Config/interface.config";
import { IoSearch } from "react-icons/io5";
import AppLogo from "../../Assets/Images/logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import * as CM from "../../Config/common.config";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../Redux/store";
import { OutLineButton } from "../../common-styles";
import CreatePostModal from "../../Modals/CreatePostModal";
import { HiOutlineHome } from "react-icons/hi2";
import { PiChatCircleDots } from "react-icons/pi";
import { FaRegCircleUser } from "react-icons/fa6";
import { BsBarChart } from "react-icons/bs";
import { ReactComponent as CreateIcon } from "./Create.svg";
import { getUserDetails } from "../../Redux/slices/userSlice";
import { logout } from "../../Redux/slices/authSlice";
import SignOutConfirmationModal from "../SignOutConfirmationModal";
import CreatorPresenceConnection from "../CreatorPresenceConnection";
import CreatorPushSubscriptionSync from "../CreatorPushSubscriptionSync";
import { clearCreatorNotificationsForSignOut } from "../../Utils/pushNotifications";

const Sidebar: React.FC = () => {
  const { id, role, isApproved, loading } = useSelector(
    (state: RootState) => state.user
  );
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [createPostModal, setCreatePostModal] = useState(false);
  const [showSignOutConfirm, setShowSignOutConfirm] = useState(false);
  const approvedCreator = CM.isCreatorRole(role) && isApproved === true;

  const defaultItems: interFace.SidebarItems[] = [
    {
      id: 1,
      icon: <HiOutlineHome />,
      title: "Home",
      link: "/home",
    },
    {
      id: 2,
      icon: <IoSearch />,
      title: "Explore",
      link: "/explore",
    },
    {
      id: 3,
      icon: <PiChatCircleDots className="flex-none" />,
      title: "Messages",
      link: "/messages",
    },
    {
      id: 4,
      icon: <CreateIcon className="flex-none create-post-icon" />,
      title: "Create",
      link: "/create",
      onClick: () => setCreatePostModal(true),
      role: "CREATOR",
    },
    {
      id: 5,
      icon: <BsBarChart className="flex-none" />,
      title: "Activity",
      link: "/activity",
      role: "CREATOR",
    },
    {
      id: 6,
      icon: <FaRegCircleUser strokeWidth={"1px"} className="flex-none" />,
      title: "Account",
      link: "/account",
    },
  ];

  const [userMenu] = useState<interFace.UserMenu[]>([
    {
      title: "Contact Support",
      link: "",
    },
    {
      title: "Edit Profile",
      link: "/profile/edit",
    },
    {
      title: "Change Password",
      link: "",
    },
    {
      title: "Payment & Billing",
      link: "",
    },
    {
      title: "Subscriptions",
      link: "",
    },
    {
      title: "Sign Out",
      link: "/logout",
    },
  ]);

  const [items, setItems] = useState<interFace.SidebarItems[]>(defaultItems);
  const { pathname } = useLocation();

  const confirmSignOut = async () => {
    setShowSignOutConfirm(false);

    await clearCreatorNotificationsForSignOut().catch(() => undefined);

    dispatch(logout());
    window.location.replace("/");
  };

  const menuClick = (link: string = "") => {
    if (link === "/logout") {
      setIsMenuOpen(false);
      setShowSignOutConfirm(true);
      return;
    }
    navigate(link);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (approvedCreator) {
      const non_creators_ids = [2];
      setItems(defaultItems.filter(({ id }) => !non_creators_ids.includes(id)));
    } else {
      setItems(defaultItems);
    }
  }, [approvedCreator]);

  useEffect(() => {
    if (!id && !loading) dispatch(getUserDetails());
  }, [dispatch, id, loading]);

  return (
    <>
      <CreatorPresenceConnection />
      <CreatorPushSubscriptionSync />

      <S.UserMenuContainer $open={isMenuOpen}>
        <S.MenuSheild
          onClick={() => setIsMenuOpen(false)}
          className="menu-sheild"
        />
        <S.UserMenu className="user-menu">
          {userMenu.map((user, i) => (
            <S.UserMenuItem
              onClick={() => menuClick(user.link)}
              key={`user-menu-${i}`}
              className="cursor-pointer"
            >
              {user.title}
            </S.UserMenuItem>
          ))}
        </S.UserMenu>
      </S.UserMenuContainer>

      <S.SidebardWrapper>
        <div>
          <S.Logo src={AppLogo} />
          <S.SidebarItems>
            {items.map((item) => {
              if (item?.role === "CREATOR" && !approvedCreator) return null;

              return (
                <S.SidebarItem
                  onClick={(e) => {
                    if (!item.onClick) return e;
                    e.preventDefault();
                    item.onClick();
                  }}
                  active={`${pathname === item.link}`}
                  to={item.link}
                  key={item.id}
                >
                  {item.icon}
                  <span className="item-title">{item.title}</span>
                </S.SidebarItem>
              );
            })}
          </S.SidebarItems>
        </div>

        <div className="mb-8 contact-us">
          <OutLineButton className="w-[80%] justify-center">
            Contact Us
          </OutLineButton>
        </div>
      </S.SidebardWrapper>

      <CreatePostModal
        onHide={() => setCreatePostModal(false)}
        show={createPostModal}
        key={"create-post-modal"}
      />
      <SignOutConfirmationModal
        show={showSignOutConfirm}
        onStay={() => setShowSignOutConfirm(false)}
        onConfirm={confirmSignOut}
      />
    </>
  );
};

export default Sidebar;
